import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './HYBRID_Asset_Profile.css';

const HYBRID_Asset_Profile = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"HYBRID_ASSET_PROFILE",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	HYBRID_ASSET_PROFILE:-1
  });


  const [HYBRID_ASSET_PROFILE, setHYBRID_ASSET_PROFILE] = React.useState(null);
  const [HYBRID_ASSET_PROFILE_D, setHYBRID_ASSET_PROFILE_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Hybrid Asset Profile');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/HYBRID_Asset_Profile',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewHYBRID_ASSET_PROFILE(clientInfo,"OpenNew");

		navigate('/HYBRID_Asset_Profile',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Asset_Profile_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutHYBRID_ASSET_PROFILE(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostHYBRID_ASSET_PROFILE(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewHYBRID_ASSET_PROFILE(clientInfo,"OpenNew");
		}
		navigate('/HYBRID_Asset_Profile',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Asset_Profile_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Asset_Profile_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Asset_Profile_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
		if(Temp_Data2.status!="New"){
			handleDeleteHYBRID_ASSET_PROFILE(Temp_Data2);
			navigate('/HYBRID_Asset_Profile#New',{replace:true});
		} 
		else 
			navigate('/HYBRID_Asset_Profile',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Asset_Profile',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Asset_Profile',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Asset_Profile',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Asset_Profile',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!HYBRID_ASSET_PROFILE) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_${i}_SECTION`;
	  const headerId = `#HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [HYBRID_ASSET_PROFILE]) ;


  
  
  var Ids = [];
  for(var Ele in HYBRID_ASSET_PROFILE){
	  for(var Sec in HYBRID_ASSET_PROFILE[Ele]){
		if(Sec == "id")
			Ids.push(HYBRID_ASSET_PROFILE[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(HYBRID_ASSET_PROFILE[Ele]["status"]);
		else if(Array.isArray(HYBRID_ASSET_PROFILE[Ele][Sec]))
			  for(var Row in HYBRID_ASSET_PROFILE[Ele][Sec])  // Convert to HYBRID_ASSET_PROFILE[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in HYBRID_ASSET_PROFILE[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["HYBRID_ASSET_PROFILE"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewHYBRID_ASSET_PROFILE(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_ASSET_PROFILE`).then((response1) => {
		if(!HYBRID_ASSET_PROFILE) 
			setHYBRID_ASSET_PROFILE(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_ASSET_PROFILE_D`).then((response2) => {
			setHYBRID_ASSET_PROFILE_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddHYBRID_ASSET_PROFILE_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewHYBRID_ASSET_PROFILE = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_ASSET_PROFILE/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setHYBRID_ASSET_PROFILE(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataHYBRID_ASSET_PROFILE = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_ASSET_PROFILE/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutHYBRID_ASSET_PROFILE = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_ASSET_PROFILE/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostHYBRID_ASSET_PROFILE = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_ASSET_PROFILE', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteHYBRID_ASSET_PROFILE = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_ASSET_PROFILE', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["1"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_0"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("1","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_0",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["1"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_1"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("1","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_1",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  

const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["1"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_2"]=value;
	Form_Data_onChange("1","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_2",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
  }; 
  

    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["1"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_3"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("1","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_3",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  

const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["1"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_4"]=value;
	Form_Data_onChange("1","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_4",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
  }; 
  


const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["1"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_5"]=value;
	Form_Data_onChange("1","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_5",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
  }; 
  


const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_6_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_6"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["1"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_6"]=value;
	Form_Data_onChange("1","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_6",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
  }; 
  

    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["2"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_0"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("2","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_0",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["2"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_1"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("2","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_1",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["2"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_2"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("2","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_2",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  

const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["2"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_3"]=value;
	Form_Data_onChange("2","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_3",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
  }; 
  

    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["2"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_4"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("2","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_4",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["2"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_5"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("2","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_5",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_6_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_6"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["2"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_6"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("2","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_6",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["3"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_0"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("3","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_0",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["3"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_1"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("3","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_1",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["3"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_2"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("3","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_2",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  

const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["4"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_0"]=value;
	Form_Data_onChange("4","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_0",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
  }; 
  


const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["4"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_1"]=value;
	Form_Data_onChange("4","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_1",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
  }; 
  


const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["4"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_2"]=value;
	Form_Data_onChange("4","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_2",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
  }; 
  

  
      
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_0"]=value ? true : false; // optionally just use boolean
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_0",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  



const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_1"]=value;
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_1",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
  }; 
  


const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_2"]=value;
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_2",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
  }; 
  

    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_3"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_3",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_4"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_4",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_5"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_5",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_6_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_6"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_6"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_6",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_7_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_7"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_7"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_7",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_8_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_8"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_8"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_8",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  

const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_9_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_9"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_9"]=value;
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_9",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
  }; 
  


const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_10_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_10"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_10"]=value;
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_10",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
  }; 
  


const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_11_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_11"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_11"]=value;
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_11",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
  }; 
  


const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_12_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_12"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_12"]=value;
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_12",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
  }; 
  

    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_13_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_13"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_13"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_13",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_14_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_14"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_14"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_14",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_15_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_15"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_15"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_15",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_16_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_16"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_16"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_16",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_17_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_17"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_17"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_17",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_18_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_18"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_18"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_18",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_19_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_19"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_19"]=value;
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_19",value,Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
  }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_20_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_20"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_20"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_20",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_21_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_21"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["8"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_21"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("8","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_21",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  

const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["9"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_0"]=value;
	Form_Data_onChange("9","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_0",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
  }; 
  

    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["9"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_1"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("9","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_1",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["9"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_2"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("9","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_2",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["9"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_3"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("9","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_3",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  
    
const HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
	Temp_Data["9"]["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_4"]=value;
	//handleAddHYBRID_ASSET_PROFILE(Temp_Data,App_Data['HYBRID_ASSET_PROFILE']);
	Form_Data_onChange("9","HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_4",value,Temp_Data);
 	//handleLastDataHYBRID_ASSET_PROFILE(Temp_Data);
    setHYBRID_ASSET_PROFILE(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!HYBRID_ASSET_PROFILE) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedHYBRID_ASSET_PROFILE =JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
  updatedHYBRID_ASSET_PROFILE[Sec] = [...updatedHYBRID_ASSET_PROFILE[Sec], newRow];
  setHYBRID_ASSET_PROFILE(updatedHYBRID_ASSET_PROFILE);
};

const handleDeleteRow = (sec,index) => {
  const updatedHYBRID_ASSET_PROFILE = JSON.parse(JSON.stringify(HYBRID_ASSET_PROFILE));
  updatedHYBRID_ASSET_PROFILE[sec].splice(index, 1);
  setHYBRID_ASSET_PROFILE(updatedHYBRID_ASSET_PROFILE);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Hybrid Asset Profile`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Hybrid Token Asset Profile ID`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`HYBRID Asset Profile ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_0" type="text" className="form-control" placeholder="HYBRID Asset Profile ID" value={HYBRID_ASSET_PROFILE["1"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_0`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter HYBRID Asset Profile ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_1" type="text" className="form-control" placeholder="Asset ID" value={HYBRID_ASSET_PROFILE["1"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_1`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Type Code`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_2"  value={HYBRID_ASSET_PROFILE["1"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_2`]} onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_2_Change} className="form-control" name="Token Type Code"  >
						  <option value="RENT_INCOME_TOKEN">RENT_INCOME_TOKEN</option>
						  <option value="REVENUE_SHARE_TOKEN">REVENUE_SHARE_TOKEN</option>
						  <option value="SALE_PROFIT_TOKEN">SALE_PROFIT_TOKEN</option>
						  <option value="EQUITY_APPRECIATION_TOKEN">EQUITY_APPRECIATION_TOKEN</option>
						  <option value="PREFERRED_EQUITY_TOKEN">PREFERRED_EQUITY_TOKEN</option>
						  <option value="COMMON_EQUITY_TOKEN">COMMON_EQUITY_TOKEN</option>
						  <option value="DEBT_NOTE_TOKEN">DEBT_NOTE_TOKEN</option>
						  <option value="HYBRID_TOKEN">HYBRID_TOKEN</option>
						  <option value="PRE_AUCTION_POOL_TOKEN">PRE_AUCTION_POOL_TOKEN</option>
						  <option value="POST_AUCTION_TOKENIZATION">POST_AUCTION_TOKENIZATION</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Type Code
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '180ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_3" type="text" className="form-control" placeholder="Asset Name" value={HYBRID_ASSET_PROFILE["1"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_3`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '180ch' }}>
						 {t(`Enter Asset Name`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Asset Category`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_4"  value={HYBRID_ASSET_PROFILE["1"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_4`]} onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_4_Change} className="form-control" name="Asset Category"  >
						  <option value="Rental Property">Rental Property</option>
						  <option value="Land">Land</option>
						  <option value="Development Project">Development Project</option>
						  <option value="Auction Asset">Auction Asset</option>
						  <option value="Distressed Asset">Distressed Asset</option>
						  <option value="Mixed-Use Asset">Mixed-Use Asset</option>
						  <option value="Operating Business">Operating Business</option>
						  <option value="Revenue Contract">Revenue Contract</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Asset Category
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Asset Subcategory`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_5"  value={HYBRID_ASSET_PROFILE["1"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_5`]} onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_5_Change} className="form-control" name="Asset Subcategory"  >
						  <option value="Single Family">Single Family</option>
						  <option value="Multifamily">Multifamily</option>
						  <option value="Commercial">Commercial</option>
						  <option value="Industrial">Industrial</option>
						  <option value="Retail">Retail</option>
						  <option value="Office">Office</option>
						  <option value="Hospitality">Hospitality</option>
						  <option value="Raw Land">Raw Land</option>
						  <option value="Entitled Land">Entitled Land</option>
						  <option value="Mixed Use">Mixed Use</option>
						  <option value="Revenue Contract">Revenue Contract</option>
						  <option value="Debt Collateral">Debt Collateral</option>
						  <option value="Other">Other</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Asset Subcategory
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Asset Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_6"  value={HYBRID_ASSET_PROFILE["1"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_6`]} onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_1_6_Change} className="form-control" name="Asset Status"  >
						  <option value="Intake">Intake</option>
						  <option value="Screening">Screening</option>
						  <option value="Due Diligence">Due Diligence</option>
						  <option value="Approved">Approved</option>
						  <option value="Offering">Offering</option>
						  <option value="Funded">Funded</option>
						  <option value="Operating">Operating</option>
						  <option value="Exited">Exited</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Archived">Archived</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Asset Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Street Address`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '200ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Street Address`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_0" type="text" className="form-control" placeholder="Street Address" value={HYBRID_ASSET_PROFILE["2"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_0`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '200ch' }}>
						 {t(`Enter Street Address`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '80ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`City`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_1" type="text" className="form-control" placeholder="City" value={HYBRID_ASSET_PROFILE["2"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_1`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '80ch' }}>
						 {t(`Enter City`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '80ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`County`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_2" type="text" className="form-control" placeholder="County" value={HYBRID_ASSET_PROFILE["2"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_2`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '80ch' }}>
						 {t(`Enter County`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`State`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_3"  value={HYBRID_ASSET_PROFILE["2"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_3`]} onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_3_Change} className="form-control" name="State"  >
						  <option value="AL">AL</option>
						  <option value="AK">AK</option>
						  <option value="AZ">AZ</option>
						  <option value="AR">AR</option>
						  <option value="CA">CA</option>
						  <option value="CO">CO</option>
						  <option value="CT">CT</option>
						  <option value="DE">DE</option>
						  <option value="FL">FL</option>
						  <option value="GA">GA</option>
						  <option value="HI">HI</option>
						  <option value="ID">ID</option>
						  <option value="IL">IL</option>
						  <option value="IN">IN</option>
						  <option value="IA">IA</option>
						  <option value="KS">KS</option>
						  <option value="KY">KY</option>
						  <option value="LA">LA</option>
						  <option value="ME">ME</option>
						  <option value="MD">MD</option>
						  <option value="MA">MA</option>
						  <option value="MI">MI</option>
						  <option value="MN">MN</option>
						  <option value="MS">MS</option>
						  <option value="MO">MO</option>
						  <option value="MT">MT</option>
						  <option value="NE">NE</option>
						  <option value="NV">NV</option>
						  <option value="NH">NH</option>
						  <option value="NJ">NJ</option>
						  <option value="NM">NM</option>
						  <option value="NY">NY</option>
						  <option value="NC">NC</option>
						  <option value="ND">ND</option>
						  <option value="OH">OH</option>
						  <option value="OK">OK</option>
						  <option value="OR">OR</option>
						  <option value="PA">PA</option>
						  <option value="RI">RI</option>
						  <option value="SC">SC</option>
						  <option value="SD">SD</option>
						  <option value="TN">TN</option>
						  <option value="TX">TX</option>
						  <option value="UT">UT</option>
						  <option value="VT">VT</option>
						  <option value="VA">VA</option>
						  <option value="WA">WA</option>
						  <option value="WV">WV</option>
						  <option value="WI">WI</option>
						  <option value="WY">WY</option>
						  <option value="DC">DC</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter State
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '15ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`ZIP Code`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_4" type="text" className="form-control" placeholder="ZIP Code" value={HYBRID_ASSET_PROFILE["2"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_4`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_4_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '15ch' }}>
						 {t(`Enter ZIP Code`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Latitude`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_5" type="text" className="form-control" placeholder="Latitude" value={HYBRID_ASSET_PROFILE["2"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_5`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_5_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Latitude`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Longitude`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_6" type="text" className="form-control" placeholder="Longitude" value={HYBRID_ASSET_PROFILE["2"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_6`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_6_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_2_6"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Longitude`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Current Owner ID`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Current Owner ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_0" type="text" className="form-control" placeholder="Current Owner ID" value={HYBRID_ASSET_PROFILE["3"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_0`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Current Owner ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`SPV ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_1" type="text" className="form-control" placeholder="SPV ID" value={HYBRID_ASSET_PROFILE["3"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_1`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter SPV ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Data Room ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_2" type="text" className="form-control" placeholder="Data Room ID" value={HYBRID_ASSET_PROFILE["3"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_2`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_3_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Data Room ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Primary Value Source`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Primary Value Source`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_0"  value={HYBRID_ASSET_PROFILE["4"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_0`]} onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_0_Change} className="form-control" name="Primary Value Source"  >
						  <option value="Rental Income">Rental Income</option>
						  <option value="Operating Revenue">Operating Revenue</option>
						  <option value="Sale Profit">Sale Profit</option>
						  <option value="Appreciation">Appreciation</option>
						  <option value="Preferred Return">Preferred Return</option>
						  <option value="Debt Interest">Debt Interest</option>
						  <option value="Hybrid">Hybrid</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Primary Value Source
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Asset Use Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_1"  value={HYBRID_ASSET_PROFILE["4"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_1`]} onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_1_Change} className="form-control" name="Asset Use Type"  >
						  <option value="Residential">Residential</option>
						  <option value="Commercial">Commercial</option>
						  <option value="Industrial">Industrial</option>
						  <option value="Retail">Retail</option>
						  <option value="Office">Office</option>
						  <option value="Hospitality">Hospitality</option>
						  <option value="Land">Land</option>
						  <option value="Mixed Use">Mixed Use</option>
						  <option value="Auction">Auction</option>
						  <option value="Other">Other</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Asset Use Type
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Tokenization Readiness Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_2"  value={HYBRID_ASSET_PROFILE["4"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_2`]} onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_4_2_Change} className="form-control" name="Tokenization Readiness Status"  >
						  <option value="Not Ready">Not Ready</option>
						  <option value="In Review">In Review</option>
						  <option value="Conditionally Ready">Conditionally Ready</option>
						  <option value="Ready">Ready</option>
						  <option value="Blocked">Blocked</option>
						  <option value="Rejected">Rejected</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Tokenization Readiness Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Map Display Enabled`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_SECTION" className="row">
			                 {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Map Display Enabled`)} <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_0_Change} 
					  checked={HYBRID_ASSET_PROFILE?.["8"]?.["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_0"] === "true" || HYBRID_ASSET_PROFILE?.["8"]?.["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_0"] === true} />
					</label>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Map Public Visibility`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_1"  value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_1`]} onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_1_Change} className="form-control" name="Map Public Visibility"  >
						  <option value="Exact Public Boundary">Exact Public Boundary</option>
						  <option value="Approximate Public Boundary">Approximate Public Boundary</option>
						  <option value="Hidden From Public">Hidden From Public</option>
						  <option value="Investor Only After Login">Investor Only After Login</option>
						  <option value="Accredited / Approved Investor Only">Accredited / Approved Investor Only</option>
						  <option value="Internal Only">Internal Only</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Map Public Visibility
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Map Listing Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_2"  value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_2`]} onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_2_Change} className="form-control" name="Map Listing Status"  >
						  <option value="Not Listed">Not Listed</option>
						  <option value="Pre-Listing Draft">Pre-Listing Draft</option>
						  <option value="Preview Only">Preview Only</option>
						  <option value="Listed - Not Investable">Listed - Not Investable</option>
						  <option value="Listed - Investment Open">Listed - Investment Open</option>
						  <option value="Paused">Paused</option>
						  <option value="Closed">Closed</option>
						  <option value="Archived">Archived</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Map Listing Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '120ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Google Map Place ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_3" type="text" className="form-control" placeholder="Google Map Place ID" value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_3`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '120ch' }}>
						 {t(`Enter Google Map Place ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Google Maps URL`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_4" type="text" className="form-control" placeholder="Google Maps URL" value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_4`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_4_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Google Maps URL`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '240ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Display Address`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_5" type="text" className="form-control" placeholder="Map Display Address" value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_5`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_5_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '240ch' }}>
						 {t(`Enter Map Display Address`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Center Latitude`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_6" type="text" className="form-control" placeholder="Map Center Latitude" value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_6`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_6_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_6"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Map Center Latitude`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Center Longitude`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_7" type="text" className="form-control" placeholder="Map Center Longitude" value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_7`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_7_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_7"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Map Center Longitude`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Default Zoom`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_8" type="text" className="form-control" placeholder="Map Default Zoom" value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_8`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_8_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_8"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Map Default Zoom`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_9"  value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_9`]} onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_9_Change} className="form-control" name="Boundary Type"  >
						  <option value="Point Only">Point Only</option>
						  <option value="Parcel Boundary">Parcel Boundary</option>
						  <option value="Building Footprint">Building Footprint</option>
						  <option value="Unit Boundary">Unit Boundary</option>
						  <option value="Multi-Parcel Boundary">Multi-Parcel Boundary</option>
						  <option value="Multi-Building Boundary">Multi-Building Boundary</option>
						  <option value="Development Site Boundary">Development Site Boundary</option>
						  <option value="Easement / Access Boundary">Easement / Access Boundary</option>
						  <option value="Estimated Boundary">Estimated Boundary</option>
						  <option value="Confidential Boundary">Confidential Boundary</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Type
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Source`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_10"  value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_10`]} onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_10_Change} className="form-control" name="Boundary Source"  >
						  <option value="Google Maps">Google Maps</option>
						  <option value="Manual Pin">Manual Pin</option>
						  <option value="County GIS Parcel">County GIS Parcel</option>
						  <option value="Assessor Parcel Map">Assessor Parcel Map</option>
						  <option value="Survey">Survey</option>
						  <option value="Title Report">Title Report</option>
						  <option value="Deed Legal Description">Deed Legal Description</option>
						  <option value="KML / KMZ Upload">KML / KMZ Upload</option>
						  <option value="GeoJSON Upload">GeoJSON Upload</option>
						  <option value="Broker / Seller Provided">Broker / Seller Provided</option>
						  <option value="Auction Source">Auction Source</option>
						  <option value="Unknown">Unknown</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Source
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Verification Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_11"  value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_11`]} onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_11_Change} className="form-control" name="Boundary Verification Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Unverified">Unverified</option>
						  <option value="Auto-Geocoded">Auto-Geocoded</option>
						  <option value="Manually Drawn">Manually Drawn</option>
						  <option value="Needs Review">Needs Review</option>
						  <option value="Verified by Platform">Verified by Platform</option>
						  <option value="Verified by Survey">Verified by Survey</option>
						  <option value="Verified by Title / County Record">Verified by Title / County Record</option>
						  <option value="Disputed">Disputed</option>
						  <option value="Hidden / Confidential">Hidden / Confidential</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Verification Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Geometry Format`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_12"  value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_12`]} onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_12_Change} className="form-control" name="Boundary Geometry Format"  >
						  <option value="Point">Point</option>
						  <option value="Bounding Box">Bounding Box</option>
						  <option value="Polygon GeoJSON">Polygon GeoJSON</option>
						  <option value="MultiPolygon GeoJSON">MultiPolygon GeoJSON</option>
						  <option value="FeatureCollection GeoJSON">FeatureCollection GeoJSON</option>
						  <option value="WKT">WKT</option>
						  <option value="KML / KMZ">KML / KMZ</option>
						  <option value="Encoded Polyline">Encoded Polyline</option>
						  <option value="Image Overlay Reference">Image Overlay Reference</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Geometry Format
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '12000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary GeoJSON`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_13" type="text" className="form-control" placeholder="Boundary GeoJSON" value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_13`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_13_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_13"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '12000ch' }}>
						 {t(`Enter Boundary GeoJSON`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '12000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary WKT`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_14" type="text" className="form-control" placeholder="Boundary WKT" value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_14`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_14_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_14"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '12000ch' }}>
						 {t(`Enter Boundary WKT`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '500ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary Bounding Box`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_15" type="text" className="form-control" placeholder="Boundary Bounding Box" value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_15`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_15_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_15"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '500ch' }}>
						 {t(`Enter Boundary Bounding Box`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Parcel ID List`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_16" type="text" className="form-control" placeholder="Parcel ID List" value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_16`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_16_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_16"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Parcel ID List`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Legal Description Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_17" type="text" className="form-control" placeholder="Legal Description Link" value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_17`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_17_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_17"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Legal Description Link`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Survey Document Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_18" type="text" className="form-control" placeholder="Survey Document Link" value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_18`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_18_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_18"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Survey Document Link`)}
                     </div>
                  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Boundary Last Verified Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_19" type="date"  value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_19`]} 
							onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_19_Change} style={{ borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_19"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Boundary Last Verified Date
					  </div>
				  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '80ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary Verified By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_20" type="text" className="form-control" placeholder="Boundary Verified By" value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_20`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_20_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_20"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '80ch' }}>
						 {t(`Enter Boundary Verified By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '1000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Disclaimer`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_21" type="text" className="form-control" placeholder="Map Disclaimer" value={HYBRID_ASSET_PROFILE["8"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_21`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_21_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_8_21"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '1000ch' }}>
						 {t(`Enter Map Disclaimer`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_0"  value={HYBRID_ASSET_PROFILE["9"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_0`]} onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_1" type="text" className="form-control" placeholder="Created By" value={HYBRID_ASSET_PROFILE["9"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_1`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_2" type="text" className="form-control" placeholder="Created At" value={HYBRID_ASSET_PROFILE["9"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_2`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_3" type="text" className="form-control" placeholder="Updated By" value={HYBRID_ASSET_PROFILE["9"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_3`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_4" type="text" className="form-control" placeholder="Updated At" value={HYBRID_ASSET_PROFILE["9"][`HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_4`]} 
						onChange={HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_01_ASSET_OWNER_SPONSOR_HYBRID_ASSET_SETUP_HYBRID_ASSET_PROFILE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default HYBRID_Asset_Profile;  